import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {extractListResponse, handleResponseError, ListResponse} from '../../common/api-helpers';
import {LeveragesForSides} from '../../components/leverage';
import {CommonListFilterQueryParamsFactory} from '../../factories/common-list-query-params.factory';
import {AssetValue} from '../../models/asset';
import {CommonListFilter} from '../../models/filters/common-list-filter';
import {NewOrder, Order, ReplaceOrCancelOrder} from '../../models/order';
import {AppConfigService} from '../config.service';

@Injectable()
export class OrderService {

    protected ordersUrl: string = this.appConfigService.api['orders'];

    protected ordersCustomFilterUrl: string = this.appConfigService.api['ordersCustomFilter'];

    constructor(
        protected httpClient: HttpClient,
        protected appConfigService: AppConfigService
    ) {}

    public getOrders(filter: CommonListFilter): Observable<ListResponse<Order>> {
        let requestParams: HttpParams;

        if (filter) {
            const params = CommonListFilterQueryParamsFactory.createQueryParamsAsString(filter);
            requestParams = new HttpParams({fromString: params});
        }

        return this.httpClient.get<ListResponse<Order>>(this.ordersUrl, {params: requestParams}).pipe(
            map(extractListResponse),
            catchError(handleResponseError)
        );
    }

    public getOrdersWithCustomFilter(filter: CommonListFilter): Observable<ListResponse<Order>> {
        let requestParams: HttpParams;

        if (filter) {
            const params = CommonListFilterQueryParamsFactory.createQueryParamsAsString(filter);
            requestParams = new HttpParams({fromString: params});
        }

        return this.httpClient.get<ListResponse<Order>>(this.ordersCustomFilterUrl, {params: requestParams}).pipe(
            map(extractListResponse),
            catchError(handleResponseError)
        );
    }

    public getOrder(idOfOrder: Order['id']): Observable<Order> {
        return this.httpClient.get<Order>(`${this.ordersUrl}/${idOfOrder}`).pipe(
            catchError(handleResponseError)
        );
    }

    public createOrder(model: NewOrder | ReplaceOrCancelOrder): Observable<any> {
        return this.httpClient.post(this.ordersUrl, model).pipe(
            catchError(handleResponseError)
        );
    }

    public requestAvailableMargin(body: NewOrder | ReplaceOrCancelOrder): Observable<AssetValue> {
        const requestAvailableMarginUrl = `${this.ordersUrl}/request-avail`;

        return this.httpClient.post<AssetValue>(requestAvailableMarginUrl, body).pipe(
            catchError(handleResponseError)
        );
    }

    /**
     * [HED-758] Fetches lists of available leverages for BUY and SELL.
     * This API was introduced for OKEx exchange, and at that time supported OKEx only.
     * For OKEx the result depends only on these order's fields: security, account.
     */
    public requestLeverages(body: NewOrder | ReplaceOrCancelOrder): Observable<LeveragesForSides> {
        const requestLeveragesUrl = `${this.ordersUrl}/request-leverages`;

        return this.httpClient.post<LeveragesForSides>(requestLeveragesUrl, body).pipe(
            catchError(handleResponseError)
        );
    }
}
